import { Dialog, Modal } from "react-aria-components";
import { Dropdown } from "src/components/Dropdown/Dropdown";
import { useScreenMinWidth } from "src/utils/hooks/useScreenMinWidth";
import passengerPickerMessage from "src/domain/SegmentScreen/SegmentHeader/PassengerPicker/PassengerPicker.message";
import { useIntl } from "react-intl";
import { CloseButton } from "src/auth/components/CloseButton/CloseButton";

export default function PassengerPickerPopout({
  children,
  label,
  isOpen = false,
  handleCloseButtonClick,
}: {
  label: string;
  children: React.ReactNode;
  isOpen?: boolean;
  handleCloseButtonClick: () => void;
}) {
  const intl = useIntl();
  const { isMdScreen } = useScreenMinWidth();

  if (isMdScreen) {
    return (
      <Dropdown
        role="dialog"
        className="top-10 mt-2 w-70 p-4"
        borderRadius="rounded_xl"
        anchor="center"
        aria-label={intl.formatMessage(
          passengerPickerMessage.passengerInfoHeader,
        )}
        isOpen={isOpen}
      >
        {children}
      </Dropdown>
    );
  }

  return (
    <Modal
      className="fixed top-0 left-0 z-[100002] flex min-h-screen w-lvw flex-col items-center overflow-auto bg-white transition-all duration-300 ease-in-out"
      aria-label={label}
      isOpen={isOpen}
    >
      <Dialog
        aria-label={label}
        className="max-h-screen w-full overflow-auto pb-20"
      >
        <div className="mb-5 flex w-full flex-row flex-wrap justify-center gap-4 px-4 pt-4 pb-3 shadow-lg">
          <h2 className="w-full text-center text-heading-sm font-semibold">
            {intl.formatMessage(passengerPickerMessage.title)}
          </h2>
          <CloseButton
            onClick={handleCloseButtonClick}
            className="absolute top-3 right-2"
          />
        </div>
        <div className="w-full px-2">{children}</div>
      </Dialog>
    </Modal>
  );
}
